import { validateNumber, validateString } from 'avilatek-utils';
import { Product, Variant } from '../../models';

export function validateProductForm(
  product: Partial<Product>,
  validationType: 'create' | 'update'
): string {
  const { variants, options } = product;
  // validate product
  if (!validateString(product.title) || String(product.title).length > 127) {
    return 'El nombre del producto es inválido';
  }

  if (!validateNumber(product.priority)) {
    return 'La prioridad del producto es inválido';
  }

  if (!validateString(product.category)) {
    return 'La categoría del producto es inválida';
  }

  if (!validateString(product.company)) {
    return 'El alido del producto es inválido';
  }

  if (!validateString(product.description)) {
    return 'La descripción del producto es inválida';
  }

  if (validationType === 'update') return '';

  if (options.length < 1 || variants.length < 1)
    return 'Debe agregar al menos una variante y una opción (color, talla, etc.)';

  // validate variants only when you create a product
  const invalidOptions = options.filter(
    (op) => op?.values?.length > 0 && !validateString(op?.name)
  );
  if (invalidOptions?.length > 0) {
    return `El campo Título de la variante es requerido`;
  }
  const invalidVariants = variants.filter(
    (v) => v.active && !validateString(v?.sku)
  );
  if (invalidVariants?.length > 0) {
    return buildVariantError(
      'El campo SKU es requerido. Las siguientes variantes no lo contienen: ',
      invalidVariants
    );
  }

  // compareAtPrice is required
  const invalidVariantsCompareAtPrice = variants.filter(
    (v) => !validateNumber(v?.compareAtPrice)
  );
  if (invalidVariantsCompareAtPrice?.length > 0) {
    return buildVariantError(
      'El precio comparativo es requerido, revise las siguientes variantes: ',
      invalidVariantsCompareAtPrice
    );
  }

  const invalidVariantsPrice = variants.filter(
    (v) =>
      v?.price > v?.compareAtPrice && v?.compareAtPrice && v?.compareAtPrice > 0
  );
  if (invalidVariantsPrice?.length > 0) {
    return buildVariantError(
      'El precio debe ser menor que el precio comparativo, revise las siguientes variantes: ',
      invalidVariantsPrice
    );
  }

  const invalidVariantsAgreedPrice = variants.filter(
    (v) => v?.agreedPrice > v?.price || v?.agreedPrice > v?.compareAtPrice
  );
  if (invalidVariantsAgreedPrice?.length > 0) {
    return buildVariantError(
      'El precio acordado debe ser menor que el precio y el precio comparativo, revise las siguientes variantes: ',
      invalidVariantsAgreedPrice
    );
  }

  const invalidVariantsPriceExists = variants.filter((v) => !v?.price);
  if (invalidVariantsPriceExists?.length > 0) {
    return buildVariantError(
      'El precio es requerido, revise las siguientes variantes: ',
      invalidVariantsPriceExists
    );
  }

  const invalidVariantsStock = variants.filter((v) => !v?.stock);
  if (invalidVariantsStock?.length > 0) {
    return buildVariantError(
      'El stock es requerido, revise las siguientes variantes: ',
      invalidVariantsStock
    );
  }

  return '';
}

const buildVariantError = (errorText: string, variants: Variant[]) => {
  const error = `${errorText} ${variants
    ?.map((v) =>
      [v?.option?.option1, v?.option?.option2, v?.option?.option3]
        .filter((o) => o !== '' && o !== null)
        .join('/')
    )
    ?.join(', ')}`;
  return error;
};
